import Annotation from './Annotation';
import Amount from './Amount';
import FhirArray from './FhirArray';
import CodeableConcept from './CodeableConcept';
import Coding from './Coding';
import FhirDateTime from './FhirDateTime';
import FhirUtcDateTime from './FhirUtcDateTime';
import Extension from './Extension';
import FhirIdentifier from './Identifier';
import Period from './Period';
import Primitive from './Primitive';
import Quantity from './Quantity';
import Range from './Range';
import Ratio from './Ratio';
import Timing from './Timing';
import Address from './Address';
import HumanName from './HumanName';
import ContactPoint from './ContactPoint';

// primitiveTypes
const Instant = Primitive;
const Time = Primitive;
const Date = Primitive;
const FhirBoolean = Primitive;
const URI = Primitive;
const OID = Primitive;
const Markdown = Primitive;
const Code = Primitive;
const FhirString = Primitive;
const Base64Binary = Primitive;
const PositiveInt = Primitive;
const UnsignedInt = Primitive;
const Integer = Primitive;
const Decimal = Primitive;

export {
  Address,
  Annotation,
  Amount,
  FhirArray,
  CodeableConcept,
  Coding,
  ContactPoint,
  FhirDateTime,
  FhirUtcDateTime,
  Extension,
  HumanName,
  FhirIdentifier,
  Period,
  Quantity,
  Range,
  Ratio,
  Timing,
  Instant,
  Time,
  Date,
  FhirBoolean,
  URI,
  OID,
  Markdown,
  Code,
  FhirString,
  Base64Binary,
  PositiveInt,
  UnsignedInt,
  Integer,
  Decimal,
};
